const en = {
  page: {
    eyebrow: 'Portfolio',
    title: 'Our Work: Flowers, Balloons & Events',
    description:
      'Weddings, quinceañeras, themed birthdays and floral centerpieces we’ve designed and installed across Maryland. Tap any project to see it larger.',
    filterLabel: 'Filter projects by type',
    count: 'projects',
  },
  filters: {
    all: 'All',
    weddings: 'Weddings',
    balloons: 'Balloons',
    celebrations: 'Celebrations',
    centerpieces: 'Centerpieces & Installations',
    themed: 'Themed Events',
    corporate: 'Corporate',
  },
  projects: {
    p1: {
      title: 'Sage Garden Sweetheart Table',
      description: 'Blush hydrangea arch over sage draping, with eucalyptus and pearl garland on the head table.',
    },
    p2: {
      title: 'Storybook First Birthday',
      description: 'Pastel balloon columns with daisy balloons and crayon accents framing a custom storybook house.',
    },
    p3: {
      title: 'Garden Quinceañera — Flowers & Balloons',
      description: 'Pink and gold balloon backdrop with floral centerpieces on every guest table outdoors.',
    },
    p4: {
      title: 'Mi Primer Año — Charro Theme',
      description: 'Cream, white and chrome-gold balloon garlands with papel picado arches and charro details.',
    },
    p5: {
      title: 'Floral Pedestal & Head Table',
      description: 'Sculptural white pedestal with seasonal blooms and pampas, paired with the sweetheart table.',
    },
    p6: {
      title: 'Pastel Baby Shower',
      description: 'Soft pastel balloon installation for a baby shower.',
    },
    p7: {
      title: 'Bridal Bouquet',
      description: 'Hand-tied bridal bouquet in the couple’s palette.',
    },
    p8: {
      title: 'Pink & Gold Quinceañera Arch',
      description: 'Balloon arch with fresh flowers for a quinceañera entrance.',
    },
    p9: {
      title: 'Balloon & Floral Centerpieces',
      description: 'Elegant table centerpieces combining balloons and fresh flowers.',
    },
    p10: {
      title: 'Corporate Event Styling',
      description: 'Brand-color balloons and florals for a corporate celebration.',
    },
  },
  lightbox: {
    close: 'Close',
    prev: 'Previous project',
    next: 'Next project',
    book: 'Book something similar',
    of: 'of',
    whatsappPrefix: 'Hi! I loved this project and want something similar:',
  },
  empty: 'More projects in this category are coming soon.',
}

const es: typeof en = {
  page: {
    eyebrow: 'Portafolio',
    title: 'Nuestro Trabajo: Flores, Globos y Eventos',
    description:
      'Bodas, quinceañeras, cumpleaños temáticos y centros de mesa que hemos diseñado e instalado en Maryland. Toque cualquier proyecto para verlo en grande.',
    filterLabel: 'Filtrar proyectos por tipo',
    count: 'proyectos',
  },
  filters: {
    all: 'Todos',
    weddings: 'Bodas',
    balloons: 'Globos',
    celebrations: 'Celebraciones',
    centerpieces: 'Centros de Mesa e Instalaciones',
    themed: 'Eventos Temáticos',
    corporate: 'Corporativos',
  },
  projects: {
    p1: {
      title: 'Mesa de Novios en Verde Salvia',
      description: 'Arco de hortensias rubor sobre telas verde salvia, con eucalipto y perlas en la mesa principal.',
    },
    p2: {
      title: 'Primer Cumpleaños de Cuento',
      description: 'Columnas de globos pastel con globos de margarita y crayones enmarcando una casita personalizada.',
    },
    p3: {
      title: 'Quinceañera en el Jardín — Flores y Globos',
      description: 'Fondo de globos rosa y oro con centros de mesa florales en cada mesa al aire libre.',
    },
    p4: {
      title: 'Mi Primer Año — Tema Charro',
      description: 'Guirnaldas de globos crema, blanco y oro con arcos de papel picado y detalles charros.',
    },
    p5: {
      title: 'Pedestal Floral y Mesa Principal',
      description: 'Pedestal blanco escultural con flores de temporada y pampas, junto a la mesa de novios.',
    },
    p6: {
      title: 'Baby Shower Pastel',
      description: 'Instalación de globos en tonos pastel para un baby shower.',
    },
    p7: {
      title: 'Ramo de Novia',
      description: 'Ramo de novia hecho a mano en la paleta de la pareja.',
    },
    p8: {
      title: 'Arco Rosa y Oro de Quinceañera',
      description: 'Arco de globos con flores frescas para la entrada de una quinceañera.',
    },
    p9: {
      title: 'Centros de Mesa de Globos y Flores',
      description: 'Centros de mesa elegantes que combinan globos y flores frescas.',
    },
    p10: {
      title: 'Decoración de Evento Corporativo',
      description: 'Globos con colores de marca y flores para una celebración corporativa.',
    },
  },
  lightbox: {
    close: 'Cerrar',
    prev: 'Proyecto anterior',
    next: 'Proyecto siguiente',
    book: 'Reservar algo similar',
    of: 'de',
    whatsappPrefix: '¡Hola! Me encantó este proyecto y quiero algo similar:',
  },
  empty: 'Pronto agregaremos más proyectos en esta categoría.',
}

export const portfolio = { en, es }
